import type { ImageParser } from './Parser';
import { JpegParser } from './JpegParser';
import { WebpParser } from './WebpParser';
import { PngParser } from './PngParser';
import { GifParser } from './GifParser';

export class ParserRegistry {
  private static parsers: Record<string, ImageParser> = {
    'jpeg': new JpegParser(),
    'webp': new WebpParser(),
    'png': new PngParser(),
    'gif': new GifParser(),
  };

  static getParser(filename: string | null): ImageParser {
    if (filename) {
      const lower = filename.toLowerCase();
      if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) {
        return this.parsers['jpeg'];
      }
      if (lower.endsWith('.webp')) {
        return this.parsers['webp'];
      }
      if (lower.endsWith('.png')) {
        return this.parsers['png'];
      }
      if (lower.endsWith('.gif')) {
        return this.parsers['gif'];
      }
    }
    // Default to JPEG for now
    return this.parsers['jpeg'];
  }
}
